import React from 'react';
import App from '../components/App';
import { SEO } from "../components/SEO/SEO";

const IndexPage = () => {
  return (
    <>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <SEO 
        pathname="/"
        description="Portfolio of Nick Jeske - Software Engineer, Android Developer & Blogger. Explore innovative projects, insightful articles, and cutting-edge software solutions."
      />
      <App />
    </>
  );
};

export default IndexPage;